import { render, staticRenderFns } from "./videoSrc.vue?vue&type=template&id=50695c4f&scoped=true"
import script from "./videoSrc.vue?vue&type=script&lang=js"
export * from "./videoSrc.vue?vue&type=script&lang=js"
import style0 from "./videoSrc.vue?vue&type=style&index=0&id=50695c4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50695c4f",
  null
  
)

export default component.exports